module.exports = __webpack_public_path__ + "img/surprised.5d349942.png";